import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { refundarchiveReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import { aclUtil } from "../../util";
import Pagination from "react-paginating";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  refundarchiveReport: PropTypes.func.isRequired,
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class RefundArchiveReports extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      menuKey: "REFUNDS_REPORT",
      path: ["Home", "Refund Archive Report"],
      links: ["home", "report/archiverefund"],
      date: new Date(),
      range: false,
      disabled: false,
      catID: "",
      merchantTypeID: "",
      dealType: "",
      refund: [],
      csvData: "",
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      limit: 10,
      pageCount: 0,
      downloadcsvData: [],
      downloadcsvData1: false,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = (date) => this.setState({ startDate: date });
  onChangeStartDateRange = (date) => this.setState({ startDateRange: date });
  changeDatePicker = (status) => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  componentDidUpdate() {
    if (!isEmpty(this.state.downloadcsvData)) {
      document.getElementById("downloadcsvData").click();
      this.setState({ downloadcsvData: [] });
    }
  }

  handlePageChange = (page) => {
    isLoading = "true";
    this.setState({
      currentPage: page,
    });

    {
      const err = this.validate();
      let formData;

      if (!err) {
        if (this.state.range == true) {
          let dateRange = this.state.startDateRange;
          formData = {
            startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
            endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
            offerIDs: this.state.offerIDs,
            merchantTypeID: this.state.merchantTypeID,
            dealType: this.state.dealType,
            page: page,
            limit: this.state.limit,
          };
        } else {
          formData = {
            startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
            catID: this.state.catID,
            offerIDs: this.state.offerIDs,
            merchantTypeID: this.state.merchantTypeID,
            dealType: this.state.dealType,
            page: page,
            limit: this.state.limit,
          };
        }
        this.props.refundarchiveReport(formData);
      }
    }
  };
  downloadCsv = (e) => {
    isLoading = "true";
    const err = this.validate();
    let formData;

    //if (!err) {
    if (this.state.range == true) {
      let dateRange = this.state.startDateRange;
      formData = {
        startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
        endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
        offerIDs: this.state.offerIDs,
        merchantTypeID: this.state.merchantTypeID,
        dealType: this.state.dealType,
        type: "all",
      };
    } else {
      formData = {
        startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
        catID: this.state.catID,
        offerIDs: this.state.offerIDs,
        merchantTypeID: this.state.merchantTypeID,
        dealType: this.state.dealType,
        type: "all",
      };
    }

    this.props.refundarchiveReport(formData);

    // }
  };
  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;
    this.setState({
      currentPage: 1,
    });
    if (!err) {
      isLoading = "true";
      this.setState({ refund: "" });
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
          endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
          merchantTypeID: this.state.merchantTypeID,
          dealType: this.state.dealType,
          page: 0,
          limit: this.state.limit,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
          merchantTypeID: this.state.merchantTypeID,
          dealType: this.state.dealType,
          page: 0,
          limit: this.state.limit,
        };
      }

      this.props.refundarchiveReport(formData);
    }
  }

  Clear = () => {};

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMerchantType();
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.combine_products == "disable") {
        this.setState({ dealType: "offer" });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
    if (!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantType: nextProps.merchantType });
      }
    }

    if (this.props.refund !== nextProps.refund) {
      console.log(nextProps);
      if (nextProps.refund) {
        isLoading = "false";
        this.setState({ refund: nextProps.refund.data.data });
        const setPageCount =
          nextProps.refund.data.total / nextProps.refund.data.per_page;
        this.setState({ reportData: nextProps.refund.data });
        this.setState({ totalRecords: nextProps.refund.data.total });
        this.setState({ pageCount: setPageCount });
        this.setState({ perPage: nextProps.refund.data.per_page });

        if (nextProps.refund.alldata !== 1) {
        }
        this.handleExport(nextProps.refund.alldata);
        this.setState({ downloadcsvData: nextProps.refund.alldata });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }
  }

  handleExport = (data) => {
    csvData = [
      [
        "#",
        "Type",
        "Transaction ID",
        "Deal ID",
        "Deal Text",
        "Amount",
        "Site Name",
        "First Name",
        "Last Name",
            "Purchase Date",
        "Refunded At",
        "Refunded Qty.",
        "Remittance",
        "Total Remittance",
      ],
    ];

    if (!isEmpty(data)) {
      data.map((refund, index) => {
        csvData.push([
          ++index,
          refund.proposal_type == "10"
            ? "Product"
            : refund.proposal_type == "11"
            ? "Auction"
            : "Offer",
          refund.transaction_id,
          refund.dealID,
          refund.dealText,
          refund.amount,
          refund.siteName,
          refund.firstName,
          refund.lastName,
            refund.createdOn,
          refund.refunded_at,
          refund.refunded_quantity,
          refund.remittance,
          refund.total_remmitence,
        ]);
      });
    }

    this.setState({ csvData: csvData });
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <CSVLink
          data={this.state.csvData}
          filename={"archive-refund-report.csv"}
          className="btn btn-default"
          id="downloadcsvData"
          style={{ display: "none" }}
        >
          Export CSV
        </CSVLink>

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent
              path={this.state.path}
              links={this.state.links}
              context={this.context}
            />
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Refund Archive Report</header>
            <div className="panel-body">
              <Row>
                <Col md={1} xs={12}>
                  <FormGroup controlId="currency">
                    <ControlLabel>Currency</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.currencyError }}
                      name="currency"
                      value={this.state.currency}
                    >
                      <option value={localStorage.getItem("symbol")}>
                        {localStorage.getItem("symbol")}
                      </option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                    >
                      <option value="">All</option>
                      <option value="offer">Offer</option>
                      <option value="products">Products</option>
                      <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="proposalType">
                    <ControlLabel>Proposal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      onChange={this.handleChange}
                      style={{ borderColor: this.state.merchantTypeIDError }}
                      name="merchantTypeID"
                      value={this.state.merchantTypeID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.merchantType) &&
                        this.state.merchantType.map((type, index) => (
                          <option
                            key={type.merchantTypeID}
                            value={type.merchantTypeID}
                          >
                            {type.merchantTypeName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {!isEmpty(this.state.refund) ? (
                    <Button
                      bsStyle="info"
                      onClick={(this.showLoader, this.downloadCsv)}
                      //onClick={this.downloadCsv}
                    >
                      CSV Export
                    </Button>
                  ) : (
                    ""
                  )}

                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}
        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th>Transaction ID</th>
                  <th>Deal ID</th>
                  <th>Deal Text</th>
                  <th>Amount</th>
                  <th>Site Name</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                   <th>Purchase Date</th>
                  <th>Refunded At</th>
                  <th>Refunded Qty.</th>
                  <th>Remittance</th>
                  <th>Total Remittance</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.refund) ? (
                  this.state.refund.map((refund, index) => (
                    <tr key={index}>
                      <td>{++index}</td>
                      <td>
                        {refund.proposal_type == "10"
                          ? "Product"
                          : refund.proposal_type == "11"
                          ? "Auction"
                          : "Offer"}
                      </td>
                      <td>{refund.transaction_id}</td>
                      <td>{refund.dealID}</td>
                      <td>{refund.dealText}</td>
                      <td>{refund.amount}</td>
                      <td>{refund.siteName}</td>
                      <td>{refund.firstName}</td>
                      <td>{refund.lastName}</td>
                               <td>{refund.createdOn}</td>
                      <td>{refund.refunded_at}</td>
                      <td>{refund.refunded_quantity}</td>
                      <td>{refund.remittance}</td>
                      <td>{refund.total_remmitence}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="text-center">
              <Pagination
                total={totalRecords}
                limit={perPage}
                pageCount={5}
                currentPage={currentPage}
              >
                {({
                  pages,
                  currentPage,
                  hasNextPage,
                  hasPreviousPage,
                  previousPage,
                  nextPage,
                  totalPages,
                  getPageItemProps,
                }) => (
                  <div className="pagination">
                    <button
                      className="btn btn-default"
                      {...getPageItemProps({
                        pageValue: 1,
                        onPageChange: this.handlePageChange,
                      })}
                    >
                      First
                    </button>

                    {hasPreviousPage && (
                      <button
                        className="btn btn-default"
                        {...getPageItemProps({
                          pageValue: previousPage,
                          onPageChange: this.handlePageChange,
                        })}
                      >
                        {"<"}
                      </button>
                    )}

                    {pages.map((page) => {
                      let activePage = null;
                      if (currentPage === page) {
                        activePage = {
                          backgroundColor: "#ccc",
                          color: "#666",
                        };
                      }
                      return (
                        <button
                          className="btn btn-default"
                          key={page}
                          style={activePage}
                          {...getPageItemProps({
                            pageValue: page,
                            onPageChange: this.handlePageChange,
                          })}
                        >
                          {page}
                        </button>
                      );
                    })}

                    {hasNextPage && (
                      <button
                        className="btn btn-default"
                        {...getPageItemProps({
                          pageValue: nextPage,
                          onPageChange: this.handlePageChange,
                        })}
                      >
                        {">"}
                      </button>
                    )}

                    <button
                      className="btn btn-default"
                      {...getPageItemProps({
                        pageValue: totalPages,
                        onPageChange: this.handlePageChange,
                      })}
                    >
                      Last
                    </button>
                  </div>
                )}
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    refund: state.reportReducer.refund,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    refundarchiveReport,
  })
)(RefundArchiveReports);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/RefundArchiveReports.js